import React from 'react';
import UserModel from '../UserModel';
import Routes from './routes';

export default function () {
    return <Routes vendorId={UserModel.getVendorId()} />;
}
